<template>
  <el-dialog :visible.sync="visible" width="60%" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="公司全称" prop="companyName">
          <el-input v-model="dataForm.companyName"  :disabled="dataForm.reviewersStatus == 1" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="公司介绍" prop="windCompanyProfile">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6}"
          placeholder="请输入内容"
          :disabled="dataForm.reviewersStatus == 1"
          v-model="dataForm.windCompanyProfile">
        </el-input>
      </el-form-item>
      <el-form-item class="hundred" label="准入城市" prop="windCity" >
              <el-select class="hundred" v-model="dataForm.windCity"  :disabled="dataForm.reviewersStatus == 1" filterable clearable multiple placeholder="请选择城市" >
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile"  class="mobileBox">

        <el-input v-model="dataForm.mobile" @input="dataForm.mobile=dataForm.mobile.replace(/[^0-9]/g,'')" style="width: 300px;" :disabled="dataForm.reviewersStatus == 1" placeholder="请输入"></el-input>

        <span> 用于门店接收账户余额短信提醒，请务必填写门店真实号码</span>

      </el-form-item>

      <p class="p">风控准入材料清单</p>
         <el-form-item   label="" prop="windCooperationAgreements" >
            <wUpload v-if="visible"  v-model="dataForm.windCooperationAgreements" :disabled="dataForm.reviewersStatus == 1" tabel="签约主体与持牌金融机构（或银行）贷款产品合作协议照片或扫描件" ></wUpload>
         </el-form-item>
         <el-form-item  label="" prop="windContracts" >
            <wUpload v-if="visible" v-model="dataForm.windContracts" :disabled="dataForm.reviewersStatus == 1"  tabel="签约主体与借款人的贷款委托服务合同1份（已签署并能看到乙方信息及收费标准），借款人信息可脱敏" ></wUpload>
         </el-form-item>
         <el-form-item label="" prop="windLicence" >
            <wUpload v-if="visible"  v-model="dataForm.windLicence"  :disabled="dataForm.reviewersStatus == 1" tabel="签约主体的营业执照（加盖公章）" ></wUpload>
         </el-form-item>
         <el-form-item label="" prop="windLegalId" >
            <wUpload v-if="visible" v-model="dataForm.windLegalId" :disabled="dataForm.reviewersStatus == 1"  tabel="签约主体的法人身份证复印件"></wUpload>
         </el-form-item>
         <el-form-item label="" prop="windOfficeAddress" >
            <wUpload v-if="visible"  v-model="dataForm.windOfficeAddress" :disabled="dataForm.reviewersStatus == 1" tabel="办公地址的房屋租赁合同" ></wUpload>
         </el-form-item>

         <el-form-item label="" prop="windLiveVideo" >
            <wUpload  v-if="visible" v-model="dataForm.windLiveVideo"  :disabled="dataForm.reviewersStatus == 1"  tabel="真实签约现场视频一份，时长不少于1分钟（借款人脸部可打码）"></wUpload>
         </el-form-item>
         <p class="p2">合同 <span>（与我司合作协议）</span></p>

         <el-form-item label="" prop="contractsBrandAffiliation" >
            <wUpload v-if="visible"  v-model="dataForm.contractsBrandAffiliation" ref="h1" tabel="品牌加盟协议" ></wUpload>
         </el-form-item>
         <el-form-item label="" prop="contractsBrandUse" >
            <wUpload v-if="visible"  v-model="dataForm.contractsBrandUse" ref="h2"   tabel="品牌使用协议" ></wUpload>
         </el-form-item>
         <el-form-item label="" prop="contractsTechnicalServices" >
            <wUpload v-if="visible"  v-model="dataForm.contractsTechnicalServices" ref="h3"  tabel="技术服务协议" ></wUpload>
         </el-form-item>

         <el-form-item label="" prop="contractsComplianceCommitment" >
            <wUpload v-if="visible" v-model="dataForm.contractsComplianceCommitment" ref="h4"  tabel="合规承诺涵"></wUpload>
         </el-form-item>
         <p class="p2">门头照</p>
         <el-form-item label="" prop="doorwayPhoto" >
            <wUpload v-if="visible" v-model="dataForm.doorwayPhoto" ref="m1" tabel="融担贷超品牌加盟商易拉宝一块并放置于门头照片"></wUpload>
         </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="() => {
        visible = false
     
      } ">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import wUpload from '@/components/w-upload/index.vue'
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      flag: false,
      
      citys:[],
      dataForm: {
        id: '',
        companyName: '',
        windCompanyProfile: '',
        windCity: '',
        mobile: '',
        windCooperationAgreements: '',
        windContracts: '',
        windLicence: '',
        windLegalId: '',
        reviewersStatus: 0,
       
        windOfficeAddress: '',
        windLiveVideo: '',
        contractsBrandAffiliation: '',
        contractsBrandUse: '',
        contractsTechnicalServices: '',
        contractsComplianceCommitment: '',
        contractsCooperationAgreements: '',
        doorwayPhoto: '',
       
      }
    }
  },
  computed: {
    dataRule () {
      return {
      
        windCooperationAgreements: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windCompanyProfile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windCity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[579]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
        windContracts: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLicence: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLegalId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windOfficeAddress: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLiveVideo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
      
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.dataForm.reviewersStatus = 0
      this.getCityOptions()
      this.$nextTick(() => {
        console.log('init')
        this.flag = true
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/accessmanagement/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if(res.data.windCity){
          res.data.windCity = res.data?.windCity.split('|')
        } else {
          res.data.windCity = []
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      // 判断是否有文件再上传
    
      if(this.$refs.h1.flag == 1 || this.$refs.h2 == 1 || this.$refs.h3 == 1 || this.$refs.h4 == 1  || this.$refs.m1 == 1){
        console.log(111)
        this.$message.warning('有文件在上传请稍后')
        return  false
      }
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        // if(this.dataForm.windCity){
        //   this.dataForm.windCity = this.dataForm.windCity.join('|')
        // }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/accessmanagement/', {...this.dataForm,
          windCity: this.dataForm.windCity.join('|')
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      }
      )
    }, 1000, { 'leading': true, 'trailing': false }),
        //初始化下拉框中的选项
        async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.filter(item => item.dictLabel != '全国').forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                 
              }
          }).catch(() => {})
      },
  },
  components:{
    wUpload,
  }
}
</script>
<style scoped lang="scss">
.p:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.p2{
 
  span{
    display: inline-block;
    // color: red;
    font-size: 12px;
    transform:translateX(-10px) scale(0.9);
   
    // transform: translateX(-4px);
  }
}
.mobileBox{
  // display: flex;
  // justify-content: start;
  span{
    // display: inline-block;
    padding: 2px 10px;
    font-weight: 400;
    font-style: normal;
    color: #D9001B;
    text-align: center;
    margin-left: 10px;
    
    background: #F5DEBC;
  }
}
</style>
